import { CODE_OK, E0 } from 'consts';
import NotifyApiError from 'errors/apiError';

export default (config) => {
  const {
    netlib,
    apiWrap,
    accessToken,
    appName: webAppName,
  } = config;

  const getAppPageTemplate = (filters, onErrorCallback) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.getAppPageTemplateV2(
        accessToken,
        {
          ...filters,
          webAppName,
        },
      );
      if (data?.code !== E0) {
        throw new NotifyApiError('getAppPageTemplate error', { message: data?.message, code: data?.code });
      }
      return data?.templates;
    },
    apiErrorCb: onErrorCallback,
  });

  const updateAppPageTemplate = (pathLocation, body) => apiWrap({
    apiQueryCb: async () => {
      const {
        id,
        isActive,
        isFavorite,
        label: name,
        templateContent,
        version,
      } = body ?? {};

      const { data } = await netlib.TemplateApi.updateAppPageTemplateV2(
        accessToken,
        id,
        {
          isActive,
          isFavorite,
          name,
          page: pathLocation,
          templateContent,
          version,
          webAppName,
        },
      );
      if (data?.code !== E0) {
        throw new NotifyApiError('updateAppPageTemplate error', { message: data?.message });
      }
      return true;
    },
  });

  const getTemplateById = (selectedTemplateId) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.getTemplateV2(accessToken, selectedTemplateId);
      if (data?.code !== E0) {
        throw new NotifyApiError('getTemplateById error', { message: data?.message });
      }
      return data?.template;
    },
  });

  const deleteTemplateById = (templateId) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.deleteAppPageTemplateV2(accessToken,
        templateId);

      if (data?.code !== CODE_OK) { // Fockn BE 🤢
        throw new NotifyApiError('deleteTemplateById error', { message: data?.message });
      }
      return true;
    },
  });

  const createAppPageTemplate = (pathLocation, body) => apiWrap({
    apiQueryCb: async () => {
      const {
        isActive,
        isFavorite,
        label: name,
        templateContent,
        version,
      } = body ?? {};

      // TBR when templates V2 will be adopted
      delete templateContent.version;

      const { data } = await netlib.TemplateApi.createAppPageTemplateV2(
        accessToken,
        {
          isActive,
          isFavorite,
          name,
          page: pathLocation,
          templateContent,
          version,
          webAppName,
        },
      );
      if (data?.code !== E0) {
        throw new NotifyApiError('createAppPageTemplate error', { message: data?.message });
      }
      return true;
    },
  });

  return {
    createAppPageTemplate,
    deleteTemplateById,
    getAppPageTemplate,
    getTemplateById,
    updateAppPageTemplate,
  };
};
